var map = require('./map');

    /**
     * Extract a list of property values.
     */
    function pluck(arr, propName){
        return map(arr, propName);
    }

    module.exports = pluck;





//////////////////
// WEBPACK FOOTER
// ./~/mout/array/pluck.js
// module id = 1556
// module chunks = 0 1 2